import React from "react";
import ChatWidget from "../components/ChatWidget";

/**
 * EmbedPage: rendered inside an iframe by embed.js on the host site.
 * Shows only the chat panel — no navigation, no page background —
 * so the host page's styles remain untouched.
 */
export default function EmbedPage() {
  return (
    <div
      data-testid="embed-page"
      style={{
        margin: 0,
        padding: 0,
        background: "#ffffff",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <ChatWidget embedded />
      </div>
    </div>
  );
}
